import axios from 'axios';
import storeUtils from './storeUtils';

// const checkToUpgradeTemplates = (oldTemplates, state) => {
//   let needSavingTemplates = false;
//   const templates = oldTemplates.map((t) => {
//     const { template, needSaving } = storeUtils.checkToUpgradeTemplate(t, state);
//     if (needSaving) {
//       needSavingTemplates = true;
//     }
//     return template;
//   });
//   return { templates, needSaving: needSavingTemplates };
// };

const prepareUserData = (data, rootState) => {
  let { templates } = data;
  // check to upgrade if not static
  if (rootState.mode !== 'static') {
    // const checks = checkToUpgradeTemplates(templates, rootState);
    // templates = checks.templates;
    // const { needSaving } = checks;
    // if (needSaving) {
    //   this.dispatch('saveUser');
    // }
  }

  // sort newest on top
  // eslint-disable-next-line
  templates = templates.sort((a, b) => b.timestamp - a.timestamp);
  return templates;
};


const saveLocalStorage = (_id) => {
  localStorage.setItem('finmodelbuilder', JSON.stringify({ _id }));
};

const clearLocalStorage = () => {
  localStorage.removeItem('finmodelbuilder');
};

const getLocalStorage = () => {
  console.log('... getting local data');
  const localDataJSON = localStorage.getItem('finmodelbuilder');
  // eslint-disable-next-line
  let _id = null;
  if (localDataJSON) {
    const localDataObj = JSON.parse(localDataJSON);
    // eslint-disable-next-line
    _id = localDataObj._id;
  }
  console.log(`_id: ${_id}`);
  return _id;
};

export default {
  state: () => ({
    languages: [],
    firstName: null,
    lastName: null,
    displayName: null,
    templates: [],
    settings: {
      language: null,
      enabledInflation: false,
      showLoginReminder: true,
      showOnboarding: true,
      plan: null,
    },
  }),
  mutations: {
    updateUserData(state, data) {
      // eslint-disable-next-line
      state._id = data._id;
      state.templates = data.templates;
      state.settings = data.settings;
      state.languages = data.languages;
      // state.email = data.email;
      state.isAnonymous = data.isAnonymous;
      if (!state.isAnonymous) {
        state.firstName = data.firstName;
        state.lastName = data.lastName;
        state.displayName = data.displayName;
        // this.dispatch('checkToSaveLocalTemplates');
      }

      /*
      let { templates } = data;
      // check to upgrade if not static
      if (state.mode !== 'static') {
        const checks = checkToUpgradeTemplates(templates);
        templates = checks.templates;
        const { needSaving } = checks;
        if (needSaving) {
          this.dispatch('saveUser');
        }
      }

      // sort newest on top
      // eslint-disable-next-line
      templates = templates.sort((a, b) => b.timestamp - a.timestamp);
      state.user.templates = templates;
      state.user.settings = data.settings;
      state.user.languages = data.languages;

      // if logged in
      if (data.email) {
        state.user.firstName = data.firstName;
        state.user.lastName = data.lastName;
        state.user.displayName = data.displayName;
        // check to add templates from localStorage
        this.dispatch('checkToSaveLocalTemplates');
      }
      state.ready.userLoaded = true;

       */
    },
  },
  actions: {
    async register({ commit }, data) {
      const response = await axios.post('/api/user/register', data);
      if (response.data.user) {
        commit('updateUserData', response.data.user);
        commit('updateLoggedIn', true);

        // go to properties
        // eslint-disable-next-line
        this._vm.router.push('/templates');
      } else {
        commit('updateState', {
          path: 'dialogs.loginResultDialogVisible',
          value: true,
        });
        commit('updateState', {
          path: 'dialogs.loginResult',
          value: 'userExists',
        });
      }
    },
    async login({ commit }, data) {
      let response;
      try {
        response = await axios.post('/api/user/login', data);
        console.dir(response.data);
        if (response.data.user) {
          commit('updateState', {
            path: 'user.anonymousId',
            value: null,
          });
          commit('updateUserData', response.data.user);
          commit('updateLoggedIn', true);

          // go to templates
          // eslint-disable-next-line
          this._vm.router.push('/templates');
        } else {
          commit('updateState', {
            path: 'dialogs.loginResultDialogVisible',
            value: true,
          });
          commit('updateState', {
            path: 'dialogs.loginResult',
            value: 'wrongUserOrPassword',
          });
        }
      } catch (e) {
        this.dispatch('handleServerError', e);
      }
    },
    // eslint-disable-next-line
    async requestResetPassword({ commit }, data) {
      commit('updateState', {
        path: 'dialogs.requestResetPassword',
        value: 'pending',
      });
      const response = await axios.post('/api/user/requestResetPassword', data);
      console.dir(response.data);
      switch (response.data.user) {
        case 'nouser':
          commit('updateState', {
            path: 'dialogs.requestResetPassword',
            value: 'nouser',
          });
          break;
        case 'loggedin':
          commit('updateState', {
            path: 'dialogs.requestResetPassword',
            value: 'loggedin',
          });
          break;
        default:
          commit('updateState', {
            path: 'dialogs.requestResetPassword',
            value: 'success',
          });
      }
    },
    // eslint-disable-next-line
    async updatePassword({ commit }, data) {
      commit('updateState', {
        path: 'dialogs.passwordUpdated',
        value: 'pending',
      });
      const response = await axios.post('/api/user/updatePassword', data);
      let dialogValue;
      switch (response.data.user) {
        case 'tokenUsedOrExpired':
          dialogValue = 'tokenexpired';
          break;
        default:
          dialogValue = 'success';
      }
      commit('updateState', {
        path: 'dialogs.passwordUpdated',
        value: dialogValue,
      });
    },
    async logout({ commit, dispatch }) {
      const response = await axios.post('/api/user/logout');
      console.dir(response.data);
      if (response.data.user === false) {
        commit('updateState', {
          path: 'loggedin',
          value: false,
        });

        // const { defaultTemplateConfig } = response.data;
        // commit('updateState', {
        //   path: 'activeTemplate',
        //   value: defaultTemplateConfig,
        // });

        await dispatch('getDefaultTemplateData');
        await dispatch('getUserData');

        // eslint-disable-next-line
        this._vm.router.push('/templates');
      } else {
        // eslint-disable-next-line
        alert('Couldn\'t logout');
      }
    },
    saveUserLocally({ state }) {
      // add missing templates to local storage (e.g. static)
      const localDataJSON = localStorage.getItem('finmodelbuilder');
      if (localDataJSON) {
        const localData = JSON.parse(localDataJSON);
        localData.templates.forEach((template) => {
          if (!state.templates.find((t) => t.uuid === template.uuid)) {
            state.templates.push(template);
          }
        });
      }
      try {
        localStorage.setItem('finmodelbuilder', JSON.stringify(state));
        console.log('... saved user locally');
      } catch (e) {
        console.log(e);
        alert('Couldn\'t save locally, please remove some templates from the gallery or sign in');
      }
    },
    async saveUser({ state }) {
      // return false;
      // for (let i = 0; i < state.templates.length; i += 1) {
      //   const template = state.templates[i];
      //   if (template.expanded) {
      //     const templateSimple = JSON.parse(JSON.stringify(template));
      //     const collapsedTemplate = storeUtils.collapseTemplate(templateSimple, state);
      //     // eslint-disable-next-line
      //     state.templates[i] = collapsedTemplate;
      //   }
      // }
      const data = state;
      data.templates = state.templates.map((template) => {
        const templateSimple = JSON.parse(JSON.stringify(template));
        const collapsedTemplate = storeUtils.collapseTemplate(templateSimple, state);
        return collapsedTemplate;
      });

      try {
        // response = await axios.post('/api/user', { data: state });
        const response = await axios.post('/api/user', data);
        if (response.data.isAnonymous) {
          // eslint-disable-next-line
          saveLocalStorage(response.data._id);
        }
        console.log('... saved user remotely');
      } catch (e) {
        this.dispatch('handleServerError', e);
      }

      // if (rootState.loggedin) {
      //   try {
      //     response = await axios.post('/api/user', { data: state });
      //     console.log('... saved user remotely');
      //   } catch (e) {
      //     this.dispatch('handleServerError', e);
      //   }
      // }

      // if (!rootState.loggedin || !response) {
      //   dispatch('saveUserLocally');
      // }

      this.dispatch('updateState', {
        path: 'saving',
        value: false,
      });

      /*  */
    },
    async getUserData({
      commit, state, rootState,
    }) {
      console.log('... getting user data');
      let response;
      let url = '/api/user';
      try {
        const anonymousId = getLocalStorage() || state.anonymousId;
        if (anonymousId) {
          url += `/${anonymousId}`;
        }
        response = await axios.get(url);
        const { data } = response;
        if (data.isAnonymous) {
          // eslint-disable-next-line
          saveLocalStorage(data._id);
        } else {
          // clear anonymous data
          clearLocalStorage();
        }
        if (data.isSignedIn) {
          // get from local storage
          // console.log('... getting local data');
          // const localData = localStorage.getItem('finmodelbuilder');
          // if (localData) {
          //   const { anonymousId } = JSON.parse(localData);
          //   state.anonymousId = anonymousId;
          // }
        // } else {
          commit('updateLoggedIn', true);
        }
        // process user data
        data.templates = prepareUserData(data, rootState);
        // eslint-disable-next-line
        rootState.ready.userLoaded = true;
        commit('updateUserData', data);
      } catch (e) {
        console.dir(e);
        this.dispatch('handleServerError', response);
      }
    },
  },
  getters: {
    userCanAddNewTemplates(state, getters, rootState) {
      const isUserLoggedIn = rootState.loggedin;
      const userHasLessThanXTemplates = state.templates.length < state.settings.maxTemplatesIfNotSignedIn;
      return isUserLoggedIn || userHasLessThanXTemplates;
    },
  },
};
